import React, {Fragment} from "react";
import {Form, FormListener} from "../form/Form";
import {AdminNote, Affiliate, User} from "../../http/protocol";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Submit} from "../form/Submit";
import {getContainer} from "../../ioc/IOCSetup";
import {RouteComponentProps, withRouter} from "react-router";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {LoadingViewState, RouterView} from "../RouterView";
import {AffiliatesService} from "../../services/AffiliatesService";
import {SelectInput} from "../form/SelectInput";

interface State extends LoadingViewState {
    affiliate? : Affiliate;
    prevAffiliateInfo? : Affiliate;
    validationMap? : any;
}

interface Props extends RouteComponentProps {

}

export const AFFILIATE_STATUS = ["PENDING", "APPROVED","SUSPENDED"];

export class AffiliateEditView extends RouterView<Props,State> implements FormListener<Affiliate>{

    service : AffiliatesService;
    constructor(props : Props){
        super(props);
        this.service = getContainer().getAffiliatesService();

        this.state = { affiliate : {}, prevAffiliateInfo : {}, validationMap : {}, loading : true};
    }

    loadContent() : Promise<any> | undefined {
        var id = (this.props.match.params as any).id;
        return this.service.getEntity(id).then((a : User) => {
            this.setState({ affiliate : a, prevAffiliateInfo : a});
        })

    }
    componentDidUpdate(prevProps : RouteComponentProps, prevState : any) {
        if((this.props.match.params as any).id !== (prevProps.match.params as any).id) {
            this.refreshContent();
        } else {
            super.componentDidUpdate(prevProps, prevState);
        }
    }

    onSubmit():Promise<any> {
        if(!this.state.affiliate) {
            return Promise.reject("Unable to save attribute");
        }

        let prevCashoutId = this.state.prevAffiliateInfo.cashoutUserId + '',
            cashoutId = this.state.affiliate.cashoutUserId + '',
            prevDefaultRevenue = this.state.prevAffiliateInfo.defaultRevenueShare + '',
            defaultRevenue = this.state.affiliate.defaultRevenueShare + '',
            prevAutoPay = this.state.prevAffiliateInfo.autoPayEnabled,
            autoPay = this.state.affiliate.autoPayEnabled,
            prevStatus = this.state.prevAffiliateInfo.status,
            currentStatus = this.state.affiliate.status,
            prevNegativeCarryover = this.state.prevAffiliateInfo.negativeCarryoverEnabled,
            negativeCarryover = this.state.affiliate.negativeCarryoverEnabled;

        this.state.affiliate.cashoutUpdateTime = this.state.prevAffiliateInfo.cashoutUpdateTime;

        if (prevCashoutId != cashoutId){
            let commentAff = `Set Affiliate ${this.state.affiliate.id} [${this.state.affiliate.username}] From Cashout User ${prevCashoutId} [${this.state.prevAffiliateInfo.cashoutUsername}] To Cashout User ${cashoutId} [${this.state.affiliate.cashoutUsername}]`;
            let note : AdminNote  ={
                type : "AFFILIATE",
                typeId :this.state.affiliate.id + "",
                comment : commentAff || ""
            };
            this.state.affiliate.cashoutUpdateTime = new Date();

            if (note.comment && note.comment.length !== 0 && note.comment.trim().length !== 0) {
                getContainer().getAdminNotesService().save(note);
            }
        }

        if (prevDefaultRevenue != defaultRevenue){
            let prevDefaultRevenueShare = ((this.state.prevAffiliateInfo.defaultRevenueShare) ? ((prevDefaultRevenue*100)+'%') : "default");
            let defaultRevenueShare = ((this.state.affiliate.defaultRevenueShare) ? ((defaultRevenue*100)+'%') : "default");
            let commentAff = `Set Affiliate ${this.state.affiliate.id} [${this.state.affiliate.username}] Default Revenue Share (Commission Rate) From ${prevDefaultRevenueShare} To ${defaultRevenueShare}`;
            let note : AdminNote  ={
                type : "AFFILIATE",
                typeId :this.state.affiliate.id + "",
                comment : commentAff || ""
            };

            if (note.comment && note.comment.length !== 0 && note.comment.trim().length !== 0) {
                getContainer().getAdminNotesService().save(note);
            }
        }

        if (prevStatus != currentStatus){
            let commentAff = `Set Affiliate ${this.state.affiliate.id} [${this.state.affiliate.username}] Status From ${prevStatus} To ${currentStatus}`;
            let note : AdminNote  ={
                type : "AFFILIATE",
                typeId :this.state.affiliate.id + "",
                comment : commentAff || ""
            };

            if (note.comment && note.comment.length !== 0 && note.comment.trim().length !== 0) {
                getContainer().getAdminNotesService().save(note);
            }
        }

        if (prevAutoPay != autoPay){
            let commentAff = `Set Affiliate ${this.state.affiliate.id} [${this.state.affiliate.username}] Auto Pay Enabled status From ${prevAutoPay} To ${autoPay}`;
            let note : AdminNote  ={
                type : "AFFILIATE",
                typeId :this.state.affiliate.id + "",
                comment : commentAff || ""
            };

            if (note.comment && note.comment.length !== 0 && note.comment.trim().length !== 0) {
                getContainer().getAdminNotesService().save(note);
            }
        }

        if (prevNegativeCarryover != negativeCarryover){
            let commentAff = `Set Affiliate ${this.state.affiliate.id} [${this.state.affiliate.username}] Negative Carryover status From ${prevNegativeCarryover} To ${negativeCarryover}`;
            let note : AdminNote  ={
                type : "AFFILIATE",
                typeId :this.state.affiliate.id + "",
                comment : commentAff || ""
            };

            if (note.comment && note.comment.length !== 0 && note.comment.trim().length !== 0) {
                getContainer().getAdminNotesService().save(note);
            }
        }

        return this.service.save(this.state.affiliate).then( (a : User) => {
            this.setState({ affiliate : a, prevAffiliateInfo : a });
        }).catch(err=>{
            throw new Error("Unable to create/save affiliate");
        });
    }

    onSubmitError(){}

    formDidUpdate(formModel:Affiliate, validationMap : any) {
        this.setState({ affiliate : formModel, validationMap : validationMap});
    }


    getTitle() : string {
        return "Edit Affiliate";
    }

    renderContent() {
        if(!this.state.affiliate) {
            return <span></span>
        }
        return (

            <Fragment>
                <Form className="form-horizontal" formListener={this} modelObject={this.state.affiliate} validationMap={this.state.validationMap}>
                    <div className={"card"}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <FormSubmitError />
                                    <FormSubmitSuccess text="Affiliate Attribute was updated successfully"/>

                                    <FormGroup className="form-group mb-3" model="email">
                                        <label>E-mail</label>
                                        <FormInput className="form-control" model="email" type="text"/>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <div className="custom-control custom-checkbox">
                                        <FormInput className="custom-control-input"  id={"enabled"} model="enabled" type="checkbox"/>
                                        <label htmlFor={"enabled"} className={"custom-control-label"}>Enabled</label>
                                    </div>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="name">
                                        <label>Name</label>
                                        <FormInput className="form-control" model="name" type="text"/>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model="username">
                                        <label>Username</label>
                                        <FormInput className="form-control" model="username" type="text"/>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model="cashoutUserId">
                                        <label>Cashout User Id</label>
                                        <FormInput className="form-control" model="cashoutUserId" type="text"/>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model="cashoutUsername">
                                        <label>Cashout Username</label>
                                        <FormInput className="form-control" model="cashoutUsername" type="text"/>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="defaultRevenueShare">
                                        <label>Default Revenue Share</label>
                                        <FormInput className="form-control" model="defaultRevenueShare" type="text"/>
                                        <span className={"help-block"}>Overrides the system default revenue share when applicable. Fractional, use 0.20 for 20%.</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="newPassword">
                                        <label>New Password</label>
                                        <FormInput className="form-control" model="newPassword" type="text"/>
                                        <span className={"help-block"}>Sets new password for the affiliate. Leave empty to keep it unchanged. Minimum 5 characters.</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="status">
                                        <label>status</label>
                                        <SelectInput  model="status" values={AFFILIATE_STATUS} className="form-control"/>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <div className="custom-control custom-checkbox">
                                        <FormInput className="custom-control-input"  id={"autoPayEnabled"} model="autoPayEnabled" type="checkbox"/>
                                        <label htmlFor={"autoPayEnabled"} className={"custom-control-label"}>Auto Pay Enabled</label>
                                    </div>
                                    <div className="hr-line-dashed"></div>

                                    <div className="custom-control custom-checkbox">
                                        <FormInput className="custom-control-input"  id={"negativeCarryoverEnabled"} model="negativeCarryoverEnabled" type="checkbox"/>
                                        <label htmlFor={"negativeCarryoverEnabled"} className={"custom-control-label"}>Negative Carryover Enabled</label>
                                    </div>
                                    <div className="hr-line-dashed"></div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"card"}>
                        <div className={"card-body"}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox float-e-margins">
                                        <div className="ibox-content">
                                            <div className="ibox-title">
                                                <h5>Actions</h5>
                                            </div>
                                            <div className="form-group">
                                                <div className="col-sm-10 col-sm-offset-2">
                                                    <Submit className="btn btn-primary waves-effect waves-light">Save Affiliate</Submit>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Fragment>
        )
    }

}

export default withRouter(AffiliateEditView);